module.exports = __webpack_public_path__ + "static/img/休眠.8be8bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/商务车（含面包）/休眠.png
// module id = FkGq
// module chunks = 76